/*
 * @Author: cn1994
 * @Date: 2023-11-10 15:10:46
 * @LastEditors: cn1994
 * @LastEditTime: 2024-03-03 15:30:17
 * @Description: 数据中心v2版本，采用嵌入quick bi
 */

const routes = [
  // 数据概览
  {
		path: "/dataCenterV2/overviewData",
    name: "overviewDataV2",
    meta:{
      title: "数据概览",
      volcengine: true,
    },
    component: () => import("../pages/dataCenterV2/overviewData.vue"),
	},
  // 销售数据
	{
		path: "/dataCenterV2/salerData",
    name: "salerDataV2",
    meta:{
      title: "销售数据",
      volcengine: true,
    },
    component: () => import("../pages/dataCenterV2/salerData.vue"),
	},
  // 教务数据
  {
		path: "/dataCenterV2/educationalData",
    name: "educationalDataV2",
    meta:{
      title: "教务数据",
      volcengine: true,
    },
    component: () => import("../pages/dataCenterV2/educationalData.vue"),
	},
  // 教学数据
  {
		path: "/dataCenterV2/teachingData",
    name: "teachingDataV2",
    meta:{
      title: "教学数据",
      volcengine: true,
    },
    component: () => import("../pages/dataCenterV2/teachingData.vue"),
	},
  // 财务数据
  {
		path: "/dataCenterV2/financeData",
    name: "financeDataV2",
    meta:{
      title: "财务数据",
      volcengine: true,
    },
    component: () => import("../pages/dataCenterV2/financeData.vue"),
	},
  // 学习数据
  {
		path: "/dataCenterV2/studyData",
    name: "studyDataV2",
    meta:{
      title: "学习数据",
      volcengine: true,
    },
    component: () => import("../pages/dataCenterV2/studyData.vue"),
	},
  {
		path: "/dataCenterV2/studyDataOld",
    name: "studyDataOldV2",
    meta:{
      title: "学习数据",
      volcengine: true,
    },
    component: () => import("../pages/dataCenterV2/studyData.vue"),
	},
  {
		path: "/dataCenterV2/reportData",
    name: "reportData",
    meta:{
      title: "报告数据",
      volcengine: true,
    },
    component: () => import("../pages/dataCenterV2/reportData.vue"),
	},
];
export default routes;
